import { ReactNode } from 'react';
import { LocalizedText } from '@mews/framework';
import { Stack, Body, Typography, Divider } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';

interface ListItemProps {
    children?: ReactNode;
    data?: ReactNode | string | number | null;
    rowLabelTextKey: Mews.TextKey;
    omitDivider?: boolean;
}

export const ListItem = ({ children, rowLabelTextKey, data, omitDivider = false }: ListItemProps) => (
    <>
        <Stack spacing="200" itemAlignment="center">
            <Body variant="secondary">
                <LocalizedText textKey={rowLabelTextKey} />
            </Body>
            {children || (
                <Typography textStyle="bodyLarge" as="div">
                    {data ?? UnicodeEntity.Dash}
                </Typography>
            )}
        </Stack>
        {!omitDivider ? <Divider /> : null}
    </>
);
